import { memo } from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Unstable_Grid2";
import { Box, TextField } from "@mui/material";
import { initLocalization } from "../../../utils/helpers";
import { BisListingNotMappedFiltersStrings } from "./locale";
import { SEARCH_FIELD_MIN_CHARS } from "../../../constants";
import { NumericInput } from "../../common/numericInput/NumericInput";

export const BisListingNotMappedFilters = memo(
  function BisListingNotMappedFilters({ filters, setFilters }) {
    initLocalization(BisListingNotMappedFiltersStrings);

    const handleChange = (e) => {
      const { name, value } = e.target;
      setFilters((prev) => ({
        ...prev,
        [name]: value,
      }));
    };

    return (
      <Grid container spacing={2} paddingY={3}>
        <Grid xs={12} sm={4}>
          <Box flexGrow={1}>
            <NumericInput
              label={BisListingNotMappedFiltersStrings.inputs.bis.id}
              name="idbis"
              value={filters.idbis}
              setValue={(val) =>
                setFilters((prev) => ({
                  ...prev,
                  idbis: val,
                }))
              }
              size="small"
              fullWidth
            />
          </Box>
        </Grid>
        <Grid xs={12} sm={8}>
          <Box flexGrow={1}>
            <TextField
              label={BisListingNotMappedFiltersStrings.inputs.bis.label}
              name="libellebis"
              size="small"
              value={filters.libellebis}
              onChange={handleChange}
              fullWidth
            />
          </Box>
        </Grid>
      </Grid>
    );
  },
);

BisListingNotMappedFilters.propTypes = {
  filters: PropTypes.object.isRequired,
  setFilters: PropTypes.func.isRequired,
};
